import React from "react";
import { motion } from "framer-motion";
import { CURRENT_PROJECTS } from "../../data/content";
import { Reveal, Kicker, RevealHeading } from "./primitives";

export const CurrentProjects = () => (
  <section id="projects" className="relative py-14 md:py-40 px-4 md:px-10 bg-[#070707] border-y border-border" data-testid="projects">
    <div className="mx-auto max-w-[1600px]">
      <div className="mb-10 md:mb-24">
        <Kicker index="02">In Production</Kicker>
        <RevealHeading text="Current Projects" className="display-h2 mt-3 md:mt-5" />
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2.5 sm:gap-3 md:gap-5">
        {CURRENT_PROJECTS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.08}>
            <motion.div
              whileHover="hover"
              whileTap={{ scale: 0.98 }}
              className="group relative aspect-[4/5] sm:aspect-[3/4] overflow-hidden bg-[#0a0a0a] border border-border/80"
              data-testid={`project-${i}`}
            >
              <motion.img
                src={p.img}
                alt={p.title}
                loading="lazy"
                variants={{ hover: { scale: 1.06 } }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                className="absolute inset-0 h-full w-full object-cover grayscale-[0.5] group-hover:grayscale-0 transition-all duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background via-background/30 to-transparent" />
              
              {/* Mobile top status tag */}
              <div className="absolute top-2.5 left-2.5 sm:top-3 sm:left-3">
                <span className="font-mono-c text-[8px] sm:text-[9px] tracking-[0.15em] uppercase text-white bg-black/60 backdrop-blur-md px-2 py-0.5 border border-white/10">
                  {p.year}
                </span>
              </div>

              <div className="absolute inset-0 flex flex-col justify-end p-3 sm:p-4 md:p-6">
                <motion.div
                  variants={{ hover: { width: "3rem" } }}
                  initial={{ width: "1.25rem" }}
                  className="h-[2px] md:h-[3px] bg-[hsl(var(--accent))] mb-2 md:mb-3"
                />
                <h3 className="font-display uppercase text-lg sm:text-2xl md:text-4xl leading-tight sm:leading-none tracking-tight text-white drop-shadow-md">
                  {p.title}
                </h3>
              </div>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
